module.exports = __webpack_public_path__ + "static/p2_iPhone-eec3fcb2c0ee4f6bb59bdad87ebcd61a.png";